import _asyncToGenerator from "/workspace/seongsudong/web/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js";
import _regeneratorRuntime from "/workspace/seongsudong/web/node_modules/@babel/runtime-corejs2/regenerator/index.js";
import "core-js/modules/es6.array.slice.js";
import "core-js/modules/es6.regexp.replace.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.regexp.to-string.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.array.find.js";
import Vue from 'vue';
import cloneDeep from 'lodash/cloneDeep';
require('dotenv').config();
export var cloneData = function cloneData(original) {
  return typeof structuredClone === 'function' ? structuredClone(original) : cloneDeep(original);
};
export default {
  cloneData: cloneData,
  unload: function unload($event) {
    var confirmationMessage = "\o/";
    $event.returnValue = confirmationMessage;
    return confirmationMessage;
  },
  isFileExist: function isFileExist(obj) {
    return obj && obj.url ? true : false;
  },
  getFileExist: function getFileExist(obj) {
    if (obj && obj.constructor === String) {
      obj = {
        url: Vue.prototype.$hostURL + obj
      };
    }
    return obj && obj.url ? obj.url : '';
  },
  getFileUrl: function getFileUrl(path) {
    return Vue.prototype.$hostURL + path;
  },
  getFileExistOld: function getFileExistOld(obj) {
    return obj && obj.length > 0 ? obj[0].url : this.getFileExist(obj);
  },
  getFileList: function getFileList(obj) {
    return this.isFileExist(obj) ? [obj] : [];
  },
  getImgOrientation: function getImgOrientation(file, obj) {
    var img = new Image();
    var vm = this;
    img.addEventListener("load", function () {
      file.orientation = img.width > img.height ? 'landscape' : 'portrait';
      obj = file;
    });
    img.src = file.url;
  },
  chunk: function chunk(data, chunk_size) {
    if (!data.length) {
      return [];
    }
    return [data.slice(0, chunk_size)].concat(this.chunk(data.slice(chunk_size), chunk_size));
  },
  getTextCroped: function getTextCroped(txt, limit, tail) {
    return txt ? this.getStripHtml(txt).substr(0, limit) + tail : '';
  },
  getStripHtml: function getStripHtml(txt) {
    var div = document.createElement('div');
    div.innerHTML = txt;
    return div.textContent || div.innerText || '';
  },
  dataToJsonParse: function dataToJsonParse(data) {
    return data ? JSON.parse(data) : data;
  },
  getMathAbs: function getMathAbs(v) {
    return Math.abs(v);
  },
  removeFroalaAlertText: function removeFroalaAlertText(text) {
    var froalaText = vm.$store.getters.getFroalaAlertText;
    return text ? text.replace(froalaText, '') : '';
  },
  // getLastMonthDate (chart) {
  //   const dt = new Date()
  //   const rtn = chart === 'top100' || chart === 'check100'
  //     ? `${dt.getFullYear()}.${dt.getMonth()+1}.${dt.getDate()}`
  //     : `${dt.getFullYear()}.${dt.getMonth()}.15`
  //   return rtn
  // },
  gotoCategory: function gotoCategory(idx) {
    vm.$router.push("/news/cate/".concat(idx));
  },
  convertOrdinalNumber: function convertOrdinalNumber(n) {
    n = parseInt(n, 10);
    var suffix = ['th', 'st', 'nd', 'rd'];
    var mod100 = n % 100;
    return suffix[(mod100 - 20) % 10] || suffix[mod100] || suffix[0];
  },
  setLanguageCookie: function setLanguageCookie(lang) {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!_this.$cookies.isKey('lang')) {
              _context.next = 3;
              break;
            }
            _context.next = 3;
            return _this.$cookies.remove("lang", '/', _this.getCookieDomain);
          case 3:
            _context.next = 5;
            return _this.$cookies.set('lang', lang, '365d', '/', _this.getCookieDomain);
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  gotoSitePage: function gotoSitePage(lang, componentName) {
    var _this2 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var toLang, dir, domain, routeName, routeParams, baseAction, idx, url, krApiURL, params, mappingIdx, path;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            // kr 버전
            toLang = lang.toString().toLowerCase();
            dir = lang !== 'KR' ? '/' + toLang : '';
            domain = window.location.origin + dir;
            routeName = _this2.$route.name;
            routeParams = _this2.$route.params;
            baseAction = _this2.findBaseActionInSiblings(routeName);
            idx = _this2.$route.params.idx;
            if (!(routeName.slice(0, 13) !== 'GallerySeries' && Object.keys(routeParams).length > 0 && idx && baseAction)) {
              _context2.next = 16;
              break;
            }
            krApiURL = Vue.prototype.$apiURL;
            params = {
              params: {
                base_action: baseAction,
                lang_code: toLang,
                model_idx: idx,
                from_lang_code: 'kr'
              }
            };
            _context2.next = 12;
            return _this2.$axios.get(krApiURL + '/multi/lang/search', params).then(function (rs) {
              if (rs.data.mapping_idx) {
                return rs.data.mapping_idx;
              }
              return null;
            });
          case 12:
            mappingIdx = _context2.sent;
            if (mappingIdx) {
              path = _this2.$route.matched[0].path;
              url = domain + path.replace(':idx', mappingIdx);
            } else {

              //notice - 주석을 풀면 사용자가 이동을 선택할 수 있음
              // const langArr = {
              //   kr: '한국어',
              //   jp: '일본어',
              //   en: '영어',
              // }
              // if (!confirm(`선택한 언어로는 동일한 컨텐츠가 없습니다. ${langArr[toLang]} 홈으로 이동할까요?`)) {
              //   return
              // }
            }
            _context2.next = 17;
            break;
          case 16:
            url = domain + _this2.$route.path;
          case 17:
            window.location = url ? url : domain + '/home';
          case 18:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  },
  gotoSite: function gotoSite(lang) {
    var _this3 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return _this3.setLanguageCookie(lang);
          case 2:
            _context3.next = 4;
            return _this3.gotoSitePage(lang);
          case 4:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }))();
  },
  findBaseActionInSiblings: function findBaseActionInSiblings(routeName) {
    var parent = this.$parent;
    if (!parent) return null;
    var target = this.getAccess === 'mobile' ? parent.$children[0].$children : parent.$children;
    var filteredChildren = target.find(function (child) {
      return child.$options && child.$options.name === routeName;
    });
    return filteredChildren ? filteredChildren.baseAction : null;
  }
};